
export const genericError = (code, message) => {
    return { "code": code, "message": message }

}